import { withRouter } from 'react-router';
import ResetPasswordInvalidLink from './reset-password-invalid-link';
import { ResetPasswordCallbackRouteProps } from '../reset-password-callback/reset-password-callback-container';

export type IProps = ResetPasswordCallbackRouteProps;

export default withRouter(ResetPasswordInvalidLink);
